exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list[data-v-f319abb6]{position:relative}.list .wrapper[data-v-f319abb6]{overflow:hidden;position:absolute;top:.5rem;left:0;right:0;bottom:0}", ""]);

// exports
